<template>
    <div class="patientlage-lista">
        <admin-lock-border />
        <div class="header">
            <h1>Patientläge</h1>
            <CustomButton type="button" variant="hollow" @click="openCreatePatientlage">
                <img src="@/assets/plus_circle_blue.svg" />
                <span>Skapa nytt patientläge</span>
            </CustomButton>
        </div>

        <kliniken-table
            v-if="patientlageList.results"
            :items="patientlageList.results"
            paginationStyle="paging"
            :columns="columns"
            :count="count"
            :limit="limit"
            :currentPage="currentPage"
            @loadPage="loadPage"
            @changeLimit="changeLimit"
            @loadMore="loadMore"
            :showBottom="true"
            :showLimitDropdown="true"
            :has-dropdown="true"
            :dropdown-actions="dropdownActions"
            @edidPatientlage="editPatientlageFromTable"
        />
    </div>
</template>

<script>
    import tabIcon from "@/assets/gear.svg";

    export default {
        name: "ListPatientlage",
        tabName: "Patientläge",
        icon: tabIcon,
    };
</script>

<script setup>
    import { onMounted, ref, onBeforeUnmount } from "vue";
    import emitter from "tiny-emitter/instance";
    import { openDialog } from "@/utils";
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import { getConfig, klinikenApi } from "@/api";
    import KlinikenTable from "@/components/Table/KlinikenTable.vue";
    import CustomButton from "@/components/Button.vue";
    import Patientlage from "@/tabs/Admin/Patientlage.vue";
    import store from "@/store";

    const patientlageList = ref([]);
    const count = ref(0);
    const columns = ref([
        {
            title: "Namn",
            name: "displayName",
        },
        {
            title: "Ordningsnummer",
            name: "ordning",
        },
        {
            title: "System",
            name: "system",
        },
        {
            title: "Systemnamn",
            name: "systemName",
        },
        {
            title: "OrginalText",
            name: "originalText",
        },
    ]);
    const dropdownActions = ref([
        {
            name: "edidPatientlage",
            title: "Redigera patientläge",
            show: () => true,
        },
    ]);

    const limit = ref(50);
    const offset = ref(0);
    const fetchBatch = ref(1);
    const params = ref({});

    const currentPage = ref(1);
    const loadPage = async (page) => {
        currentPage.value = page;
        offset.value = (page - 1) * limit.value;
        await fetchpatientlageList();
    };
    const loadMore = async () => {
        fetchBatch.value++;
        await this.fetchpatientlageList();
    };

    const changeLimit = async (dropdownLimit) => {
        fetchBatch.value = 1;
        limit.value = dropdownLimit;
        await fetchpatientlageList();
    };

    const fetchpatientlageList = async () => {
        params.value = { ...params.value, limit: limit.value, offset: offset.value };
        if (limit.value > 0) {
            params.value["limit"] = limit.value * fetchBatch.value;
        }
        try {
            const response = await klinikenApi.get(
                "/operation/kodverk/oplagen/",
                getConfig({ params: { ...params.value } })
            );
            patientlageList.value = response.data;
            count.value = response.data.count;
        } catch (error) {
            openDialog("Kunde inte hämta Patientläge.", "warning");
        }
    };
    const openCreatePatientlage = () => {
        store.dispatch("tabs/openTab", {
            component: Patientlage,
            parameters: { redigera: false },
        });
    };
    const editPatientlageFromTable = (patientlage) => {
        store.dispatch("tabs/openTab", {
            component: Patientlage,
            parameters: {
                redigera: true,
                ...patientlage,
            },
        });
    };

    onMounted(() => {
        fetchpatientlageList();
        emitter.on("Patientlage-table-uppdaterad", fetchpatientlageList);
    });

    onBeforeUnmount(() => {
        emitter.off("Patientlage-table-uppdaterad", fetchpatientlageList);
    });
</script>
<style lang="scss">
    .patientlage-lista {
        .header {
            h1 {
                margin: 0;
            }

            display: flex;
            gap: 20px;
            align-items: center;
        }
    }
</style>
